import PhotoSwipeLightbox from 'photoswipe/lightbox';

export function ofsaPhotoSwipeGallery() {
	const galleries = document.querySelectorAll( '.ofsa-gallery' );

	galleries.forEach( ( gallery ) => {
		const lightbox = new PhotoSwipeLightbox( {
			gallery,
			children: 'a',
			pswpModule: () => import( 'photoswipe' ),
		} );

		lightbox.init();
	} );
}
